module.exports = __webpack_public_path__ + "5eda9d6fc15f43d5e35890749bd6825f.png";